export default [
    {
        path: '',
        name: 'pageVisiMisi',
        component: () => import('./page-visi-misi')
    }
]